<!-- close -->
<button class="_close"
        (click)="modalClose()"><i class="_close__icon"></i></button>

<div class="_message">
    <p class="_message__copy">{{ 'A new version of this app is available.' | translate }}</p>
</div>

<div class="_actions">
    <!-- close -->
    <button class="_cancel"
            (click)="modalClose()">{{ 'Close' | translate }}</button>

    <button class="_action"
            (click)="reload()">{{ 'Update now' | translate }}</button>
</div>